(function ($) {

  if ($(".hero-slider .hero-slide").length > 1) {
    $(".hero-slider").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: true,
      arrows: true,
      prevArrow: '<button type="button" class="slick-prev">Previous<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M12.175 9H0V7H12.175L6.575 1.4L8 0L16 8L8 16L6.575 14.6L12.175 9Z" fill="#F9F6F2"/></svg></button>',
      nextArrow: '<button type="button" class="slick-next">Next<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M12.175 9H0V7H12.175L6.575 1.4L8 0L16 8L8 16L6.575 14.6L12.175 9Z" fill="#F9F6F2"/></svg></button>',
      autoplay: true,
      autoplaySpeed: 8000
    });
  }

})(jQuery);